import { useTranslation } from 'react-i18next';
import { type OptionalAssets } from '@monorepo/types';
import { type CreditCartAsset, CreditEventType } from '../credit-events.types';
import CreditEventsContentLayout from './credit-events-content-layout';

interface ExpiringCreditContentProps {
  type: CreditEventType;
  creditAmount: number;
  onRedeem: () => void;
  onSeeAllCredits: () => void;
  cartAssets?: CreditCartAsset[];
  onRedeemForAsset?: (asset: OptionalAssets) => void;
  onNewOrder?: () => void;
}

const ExpiringCreditContent = ({
  type,
  creditAmount,
  onRedeem,
  onSeeAllCredits,
  cartAssets,
  onRedeemForAsset,
  onNewOrder,
}: ExpiringCreditContentProps) => {
  const { t } = useTranslation(['creditEventsModal']);

  return (
    <CreditEventsContentLayout
      type={type}
      title={t('creditEventsModal:expiring_credit.title_line1')}
      titleLine2={t('creditEventsModal:expiring_credit.title_line2')}
      body={t('creditEventsModal:expiring_credit.body_line1', {
        amount: creditAmount,
      })}
      bodyLine2={t('creditEventsModal:expiring_credit.body_line2')}
      footnote={t('creditEventsModal:expiring_credit.footnote')}
      redeemLabel={t('creditEventsModal:redeem_credits_button')}
      seeAllLabel={t('creditEventsModal:show_all_credits_button')}
      onRedeem={onRedeem}
      onSeeAllCredits={onSeeAllCredits}
      cartAssets={cartAssets}
      onRedeemForAsset={onRedeemForAsset}
      onNewOrder={onNewOrder}
    />
  );
};

export default ExpiringCreditContent;
